import script from "./CustomPhoneInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomPhoneInput.vue?vue&type=script&setup=true&lang=ts"

import "./CustomPhoneInput.vue?vue&type=style&index=0&id=1e23a927&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e23a927"]])

export default __exports__